/* eslint-disable react/no-array-index-key */
import { Formik, FieldArray, ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import { Button, Typography, Space, message } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { Form, InputNumber, Select, Input } from 'formik-antd';
import * as Yup from 'yup';
// import { Debug } from 'components/forms/Debug';
import { Box } from 'atoms';

const UOM = [
	{ label: 'Packet', value: 'pkt' },
	{ label: 'Boxes', value: 'bxs' },
	{ label: 'Bundle', value: 'bnd' },
	{ label: 'Carton', value: 'ctn' },
	{ label: 'Dozen', value: 'dzn' },
	{ label: 'Gross', value: 'grs' },
	{ label: 'Lot', value: 'lot' },
	{ label: 'Rack', value: 'rck' },
	{ label: 'Roll', value: 'rll' },
	{ label: 'Sheet', value: 'sht' },
];
const { Title } = Typography;

const LRGoodsValidation = Yup.object().shape({
	goods_details: Yup.array(
		Yup.object({
			goods_description: Yup.string().required().label('Description'),
			goods_quantity: Yup.number().min(1).required().label('Quantity'),
			goods_uom: Yup.string().required('Missing').label('UOM').nullable(),
			goods_length: Yup.number().min(1).label('Length').nullable(),
			goods_width: Yup.number().min(1).label('Width').nullable(),
			goods_height: Yup.number().min(1).label('Height').nullable(),
			goods_weight: Yup.number().min(0.01, 'to be > 0.01').label('Weight').nullable(),
		})
	)
		.required('Goods are empty')
		.min(1, 'Need atleast one good'),
});

const defaultValues = [
	{
		goods_description: '',
		goods_quantity: '',
		goods_uom: '',
		goods_length: '',
		goods_width: '',
		goods_height: '',
		goods_weight: '',
	},
];

export function LRGoodsDetails({ formRef, formdata, isEditMode }) {
	const { goods_details } = formdata;
	return (
		<Box backgroundColor="#f5f5f5" textAlign="center">
			<div style={{ textAlign: 'center' }}>
				<Title level={4}>Goods Details</Title>
			</div>
			<Formik
				initialValues={{
					goods_details: goods_details || defaultValues,
				}}
				innerRef={formRef}
				validationSchema={LRGoodsValidation}
				enableReinitialize
				onSubmit={() => null}
			>
				{({ values }) => (
					<Form
						autoComplete="off"
						className={!isEditMode ? 'disabled-div' : ''}
						disabled={!isEditMode}
					>
						<FieldArray
							name="goods_details"
							render={(arrayHelpers) => (
								<>
									{values.goods_details.map((_, index) => (
										<Space key={index} align="baseline" wrap>
											<Form.Item
												name="goods_description"
												label="Description *"
											>
												<div>
													<Input
														name={`goods_details.${index}.goods_description`}
														placeholder="Description"
														maxLength={20}
													/>
												</div>
												<ErrorMessage
													name={`goods_details.${index}.goods_description`}
												>
													{(msg) => (
														<div style={{ color: 'red' }}>{msg}</div>
													)}
												</ErrorMessage>
											</Form.Item>
											<Form.Item name="goods_quantity" label="Quantity *">
												<div>
													<InputNumber
														name={`goods_details.${index}.goods_quantity`}
														placeholder="Quantity in Nos"
														controls={false}
														precision={2}
														style={{ width: '200px' }}
													/>
												</div>
												<ErrorMessage
													name={`goods_details.${index}.goods_quantity`}
												>
													{(msg) => (
														<div style={{ color: 'red' }}>{msg}</div>
													)}
												</ErrorMessage>
											</Form.Item>
											<Form.Item name="goods_uom" label="UOM *">
												<div>
													<Select
														name={`goods_details.${index}.goods_uom`}
														showSearch
														filterOption={(input, option) =>
															option.label
																.toLowerCase()
																.indexOf(input.toLowerCase()) >= 0
														}
														options={UOM}
														placeholder="UOM"
														style={{ width: '150px' }}
													/>
												</div>
												<ErrorMessage
													name={`goods_details.${index}.goods_uom`}
												>
													{(msg) => (
														<div style={{ color: 'red' }}>{msg}</div>
													)}
												</ErrorMessage>
											</Form.Item>
											<Form.Item name="goods_length" label="Length">
												<div>
													<InputNumber
														name={`goods_details.${index}.goods_length`}
														placeholder="Length in IN"
														controls={false}
														precision={2}
														style={{ width: '100px' }}
													/>
												</div>
												<ErrorMessage
													name={`goods_details.${index}.goods_length`}
												>
													{(msg) => (
														<div style={{ color: 'red' }}>{msg}</div>
													)}
												</ErrorMessage>
											</Form.Item>
											<Form.Item name="goods_width" label="Width">
												<div>
													<InputNumber
														name={`goods_details.${index}.goods_width`}
														placeholder="Width in IN"
														controls={false}
														precision={2}
														style={{ width: '100px' }}
													/>
												</div>
												<ErrorMessage
													name={`goods_details.${index}.goods_width`}
												>
													{(msg) => (
														<div style={{ color: 'red' }}>{msg}</div>
													)}
												</ErrorMessage>
											</Form.Item>
											<Form.Item name="goods_height" label="Height">
												<div>
													<InputNumber
														name={`goods_details.${index}.goods_height`}
														placeholder="Height in IN"
														controls={false}
														precision={2}
														style={{ width: '100px' }}
													/>
												</div>
												<ErrorMessage
													name={`goods_details.${index}.goods_height`}
												>
													{(msg) => (
														<div style={{ color: 'red' }}>{msg}</div>
													)}
												</ErrorMessage>
											</Form.Item>
											<Form.Item name="goods_weight" label="Weight">
												<div>
													<InputNumber
														name={`goods_details.${index}.goods_weight`}
														placeholder="Weight in KG"
														controls={false}
														precision={2}
														style={{ width: '100px' }}
													/>
												</div>
												<ErrorMessage
													name={`goods_details.${index}.goods_weight`}
												>
													{(msg) => (
														<div style={{ color: 'red' }}>{msg}</div>
													)}
												</ErrorMessage>
											</Form.Item>
											<MinusCircleOutlined
												onClick={() => {
													if (values.goods_details.length < 2) {
														message.info('Need atleast one item.');
													} else {
														arrayHelpers.remove(index);
													}
												}}
											/>
										</Space>
									))}
									<div>
										<Button
											type="dotted"
											onClick={() => {
												if (values.goods_details.length > 4) {
													message.info('Not more than 5 items allowed.');
												} else {
													arrayHelpers.push(values.length);
												}
											}}
										>
											Add Goods
										</Button>
									</div>
								</>
							)}
						/>
						{/* <Debug /> */}
					</Form>
				)}
			</Formik>
		</Box>
	);
}

LRGoodsDetails.propTypes = {
	formRef: PropTypes.object,
	formdata: PropTypes.object,
	isEditMode: PropTypes.bool,
};
